import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';
import { URLS, Url } from '@wix/da-url';
const GoToTierDashboard = ({ deviation })=>{
    var _deviation_tier;
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItemLink, {
        label: t('deviationview.tierCard.moreActionsMenu.item.goToTierDashboard'),
        href: `${Url.buildFromPath(URLS.CUSTOMER_DASHBOARD)}?subproductid=${(_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.subproductId}`
    });
};
GoToTierDashboard.displayName = 'GoToTierDashboard';
export default GoToTierDashboard;
